import Service from './service';

export default class EventLogsService extends Service {
  baseApi = '/event-logs';

  async getEventLogs(query) {
    const url = `${this.baseApi}`;
    return await this.getResource(url, query);
  }
}
